module.exports = __webpack_public_path__ + "media/images/menu-51408d7b.png";